/**
 * AdminResellerViewsRpcClient - AtomRpc integration for the admin reseller
 * name-resolved view endpoints (rates / customers / earnings + attribution).
 *
 * Requires admin authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminResellerViewsRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminResellerViewsRpcClient extends AtomRpc.Tag<AdminResellerViewsRpcClient>()(
  "AdminResellerViewsRpcClient",
  {
    group: AdminResellerViewsRpcs,
    protocol: makeRpcClientLayer(AdminResellerViewsRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
